<template>
  <v-container>
    <v-row justify="center" class="mt-2">
      <v-col cols="auto" class="d-flex flex-column align-center">
        <v-badge
          overlap
          color="white"
          :content="null"
          style="cursor: pointer"
          offset-x="20"
        >
          <template v-slot:badge>
            <v-btn
              icon
              small
              color="primary"
              @click.stop="$emit('update:showAvatarEdit', true)"
              style="box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <v-avatar width="72" v-if="employee.image_path">
            <v-img :src="conf.apiUrlBase + '/gallery/' + employee.image_path"></v-img>
          </v-avatar>
          <v-avatar width="72" height="72px" v-else>
            <v-icon size="72px">mdi-account-circle</v-icon>
          </v-avatar>
        </v-badge>
        <div class="mt-2 font-weight-medium" style="font-size: 1.1em">
          {{ toLatin(employee.name) }} {{ toLatin(employee.lastname) }}
        </div>
      </v-col>
    </v-row>
    <global-dialog-card
      v-model="showAvatarEdit"
      :max-width="350"
      :title="$t('add_new_image')"
    >
      <v-file-input
        append-icon="mdi-camera"
        :label="$t('choose_image')"
        :prepend-icon="false"
        @change="$emit('upload', $event)"
        class="custom-input mt-4"
        filled
        hide-details
        accept="image/*"
      ></v-file-input>

      <template #actions>
        <v-btn text @click="$emit('update:showAvatarEdit', false)">
          {{ $t("cancel") }}
        </v-btn>
      </template>
    </global-dialog-card>
  </v-container>
</template>

<script>
export default {
  name: "EmployeeAvatarSection",
  props: {
    employee: Object,
    conf: Object,
    showAvatarEdit: Boolean,
  },
  emits: ["upload", "update:showAvatarEdit"],
};
</script>
